import React from 'react';

import { Badge } from '@warp-ds/react';

export type SimpleBapSearchAdProps = {
  layout?: 'grid' | 'list';
  onClick?: () => void;
};

export function SponsoredListingAd({
  layout = 'grid',
  onClick
}: SimpleBapSearchAdProps) {
  // Mock data
  const mockData = {
    heading: 'Sponsored Listing Placeholder',
    price: '1 500 kr',
    location: 'Oslo',
    date: '2 days ago',
    organization: 'Company Name',
    imageUrl: 'https://placehold.co/400x533', // 3:4 aspect ratio
    label: 'Paid Position',
    tradeType: 'For sale'
  };
  const containerStyle: React.CSSProperties =
    layout === 'grid'
      ? {
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#fff',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }
      : {
          position: 'relative',
          display: 'grid',
          gridTemplateColumns: '1fr 2fr',
          gap: '16px',
          backgroundColor: '#fff',
          borderRadius: '8px',
          overflow: 'hidden',
          padding: '8px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        };

  const imageStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center'
  };

  const heartButtonStyle: React.CSSProperties = {
    position: 'absolute',
    top: '6px',
    right: '6px',
    zIndex: 20,
    minHeight: '44px',
    minWidth: '44px',
    borderRadius: '50%',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    transition: 'background-color 0.2s ease-in-out'
  };

  return (
    <article style={containerStyle} onClick={onClick}>
      {/* Image */}
      <div style={{ position: 'relative' }}>
        <img
          src={mockData.imageUrl}
          alt={mockData.heading}
          style={imageStyle}
        />
        {mockData.label && (
          <div style={{ position: 'absolute', top: '8px', left: '8px' }}>
            <Badge variant="info">{mockData.label}</Badge>
          </div>
        )}
      </div>

      {/* Content */}
      <div
        style={{
          padding: layout === 'grid' ? '8px' : '0',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}
      >
        {/* Price */}
        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
          {mockData.price}
        </div>

        {/* Heading */}
        <h2
          style={{
            margin: 0,
            fontSize: '14px',
            fontWeight: 'normal',
            lineHeight: '1.4'
          }}
        >
          {mockData.heading}
        </h2>

        {/* Location and Date */}
        <div
          style={{
            fontSize: '12px',
            color: '#666',
            display: 'flex',
            gap: '8px'
          }}
        >
          <span>{mockData.location}</span>
          <span>{mockData.date}</span>
        </div>

        {/* Organization */}
        {mockData.organization && (
          <div style={{ fontSize: '12px', color: '#666' }}>
            {mockData.organization}
          </div>
        )}
      </div>
      {/* Heart Button */}
      <button
        style={heartButtonStyle}
        aria-label="Lägg till i favoriter"
        type="button"
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.backgroundColor =
            'rgba(0, 0, 0, 0.05)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.backgroundColor =
            'transparent';
        }}
        onClick={(e) => {
          e.stopPropagation();
          // Handle favorite toggle
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 16 16"
        >
          <path
            fill="rgba(255, 255, 255, 0.7)"
            stroke="rgba(0, 0, 0, 0.8)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M8.002 14.5 2.035 7.892a3.888 3.888 0 0 1-.99-2.057 3.93 3.93 0 0 1 .328-2.267v0A3.528 3.528 0 0 1 2.415 2.23a3.425 3.425 0 0 1 1.532-.682 3.39 3.39 0 0 1 1.667.131
  3.454 3.454 0 0 1 1.412.914l.976 1.035.974-1.034c.39-.418.875-.731 1.412-.913a3.39 3.39 0 0 1 1.665-.131 3.43 3.43 0 0 1 1.532.681c.448.352.806.81 1.041 1.336v0c.332.704.447
  1.494.329 2.267a3.885 3.885 0 0 1-.99 2.056L8.002 14.5Z"
          />
        </svg>
      </button>
    </article>
  );
}
